import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3 sm:grid-cols-2" }
const _hoisted_2 = { class: "col-span-2 flex flex-col gap-2" }
const _hoisted_3 = {
  key: 0,
  class: "col-span-2 flex flex-row items-center gap-2"
}
const _hoisted_4 = { class: "text-xs font-bold" }

import { Checkbox } from '@/components/ui/checkbox';
    import { CheckboxGroupRoot, useFilter } from 'reka-ui';
    import { Company } from '@/types';
    import { Input } from '@/components/ui/input';
    import { InputRow, Select } from '@/components/ui/form';
    import { Label } from '@/components/ui/label';
    import { optionsYesNo } from '@/utils/form';
    import { ref, computed } from 'vue';
    import { Separator } from '@/components/ui/separator';
    import { useCompanyData } from '@/composables/useCompanyData';
    import Loading from '@/components/Loading.vue';
    import SearchInput from '@/components/SearchInput.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RoleGeneralForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    const { companies, isPlaceholderDataCompanies } = useCompanyData();

    const props = __props;

    const searchTerm = ref('');
    const { contains } = useFilter({ sensitivity: 'base' });

    const filteredCompanies = computed(() =>
        companies.value.filter((company: Company) => contains(company.name, searchTerm.value)),
    );

    const allSelected = computed({
        get: () => props.form.role_company_ids.length === companies.value.length,
        set: () => toggleAll(),
    });

    const toggleAll = () => {
        props.form.role_company_ids = allSelected.value
            ? []
            : companies.value.map((company: Company) => company.id);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "name",
      label: "roles.table.name"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "name",
          modelValue: _ctx.form.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
          autocomplete: "name",
          placeholder: _ctx.$t('roles.table.name')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "display_name",
      label: "roles.table.display_name"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "display_name",
          modelValue: _ctx.form.display_name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.display_name) = $event)),
          autocomplete: "display_name",
          placeholder: _ctx.$t('roles.table.display_name')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "is_client_text",
      label: "roles.table.is_client_text"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Select), {
          modelValue: _ctx.form.is_client,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.is_client) = $event)),
          options: _unref(optionsYesNo),
          translate: true
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "description",
      label: "roles.table.description"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "description",
          modelValue: _ctx.form.description,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.description) = $event)),
          autocomplete: "description",
          placeholder: _ctx.$t('roles.table.description')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Label), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('roles.select.companies.placeholder')), 1)
        ]),
        _: 1
      }),
      _createVNode(SearchInput, {
        placeholder: _ctx.$t('roles.select.companies.search_options.default'),
        modelValue: searchTerm.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchTerm).value = $event)),
        disabled: _unref(isPlaceholderDataCompanies)
      }, null, 8, ["placeholder", "modelValue", "disabled"])
    ]),
    (!_unref(isPlaceholderDataCompanies))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(Label), { class: "flex flex-row items-center gap-2 font-normal" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Checkbox), {
                modelValue: allSelected.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((allSelected).value = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("span", null, _toDisplayString(allSelected.value
                        ? _ctx.$t('roles.select.texts.unselectAll')
                        : _ctx.$t('roles.select.texts.selectAll')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Separator), {
            orientation: "vertical",
            class: "h-2.5!"
          }),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.form.role_company_ids.length) + " " + _toDisplayString(_ctx.$t('roles.select.texts.selectedOptions')), 1)
        ]))
      : _createCommentVNode("", true),
    (!_unref(isPlaceholderDataCompanies))
      ? (_openBlock(), _createBlock(_unref(CheckboxGroupRoot), {
          key: 1,
          modelValue: _ctx.form.role_company_ids,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.role_company_ids) = $event)),
          class: "col-span-2 -mx-5 grid grid-cols-2 gap-2 px-5 sm:grid-cols-4"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCompanies.value, (company) => {
              return (_openBlock(), _createBlock(_unref(Label), { class: "flex flex-row items-center gap-2 font-normal break-all" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Checkbox), {
                    value: company.id
                  }, null, 8, ["value"]),
                  _createElementVNode("span", null, _toDisplayString(company.name), 1)
                ]),
                _: 2
              }, 1024))
            }), 256))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_unref(isPlaceholderDataCompanies))
      ? (_openBlock(), _createBlock(Loading, {
          key: 2,
          class: "col-span-2"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})